module.exports = __webpack_public_path__ + "assets/magnolia-cms.2ff93f29.svg";